import {HttpClient, HttpParams} from "@angular/common/http";
import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {GetUserListDto} from "./dto/get-user-list.dto";
import {UserListDto} from "./dto/user-list.dto";

@Injectable({
  providedIn: 'root'
})
export class UsersListService {

    constructor(private httpClient: HttpClient) {
    }

    /**
     * Fetch user by given criteria
     * @param queryParams
     */
    public getUsers(queryParams?: GetUserListDto): Observable<UserListDto> {
        const httpParams = new HttpParams({fromObject: {...queryParams}})

        return this.httpClient.get<UserListDto>('users', {
            params: httpParams
        });
    }
}
